import {
  ANNOTATIONS_COLOR_LEGEND_FIELD,
  DELETE_ANNOTATIONS_ERROR_MESSAGE,
  DELETE_ANNOTATIONS_SUCCESS_MESSAGE,
  DISPLAYED_EXTERNAL_ANNOTATIONS,
  FILE_TYPE_ERROR_MESSAGE,
  GEOJSON_FILE_EXTENSION,
  HALO_ANNOTATIONS_FILE_EXTENSION,
  IMAGE_SCOPE_ANNOTATIONS_FILE_EXTENSION,
  SVS_FILE_EXTENSION,
  UPLOAD_ANNOTATIONS_ERROR_MESSAGE,
  UPLOAD_ANNOTATIONS_SUCCESS_MESSAGE,
} from 'components/ImageViewer/constants';
import { updateSlide as updateSlideState } from 'store/slices/slidesSlice';

export const isMatchingFile = (slideName, fileName) =>
  slideName.replace(SVS_FILE_EXTENSION, '') ===
    fileName.replace(GEOJSON_FILE_EXTENSION, '') ||
  slideName.replace(SVS_FILE_EXTENSION, '') ===
    fileName.replace(HALO_ANNOTATIONS_FILE_EXTENSION, '') ||
  slideName.replace(SVS_FILE_EXTENSION, '') ===
    fileName.replace(IMAGE_SCOPE_ANNOTATIONS_FILE_EXTENSION, '');

export const handleUploadAnnotationsAttachment = async (
  file,
  currentSlide,
  dispatch,
  preferences,
  showError,
  showSuccess,
  getSlide,
  setIsLoading,
  uploadSlideAnnotation,
) => {
  if (!file) {
    return;
  }
  const fileExtension = file.file.name.split('.').pop();
  if (
    fileExtension !== 'geojson' &&
    fileExtension !== 'annotations' &&
    fileExtension !== 'xml'
  ) {
    showError(FILE_TYPE_ERROR_MESSAGE);

    return;
  }
  const formData = new FormData();
  formData.append('file', file.file);
  formData.append('provider', file.type);
  formData.append('slide_uuid', currentSlide.uuid);

  try {
    setIsLoading(true);
    await uploadSlideAnnotation(formData).unwrap();
    const { data } = await getSlide({ slideUUID: currentSlide.uuid });
    if (data) {
      dispatch(updateSlideState(data));
      showSuccess(UPLOAD_ANNOTATIONS_SUCCESS_MESSAGE);
    }
  } catch (error) {
    showError(UPLOAD_ANNOTATIONS_ERROR_MESSAGE);
  } finally {
    setIsLoading(false);
  }
};

export const handleDeleteAnnotationsAttachment = async (
  currentSlide,
  annotationUUID,
  preferences,
  dispatch,
  setIsConfirmModalOpen,
  showError,
  showSuccess,
  getSlide,
  toggleAnnotationVisibility,
  setIsLoading,
  deleteSlideAnnotation,
) => {
  try {
    setIsLoading(true);
    await deleteSlideAnnotation({ annotationUUID }).unwrap();
    const { data } = await getSlide({ slideUUID: currentSlide.uuid });
    if (data) {
      dispatch(updateSlideState(data));
      setIsConfirmModalOpen(false);
      showSuccess(DELETE_ANNOTATIONS_SUCCESS_MESSAGE);
    }
    const isAnnotationVisible =
      preferences[DISPLAYED_EXTERNAL_ANNOTATIONS].includes(annotationUUID);
    if (isAnnotationVisible) toggleAnnotationVisibility(annotationUUID);
  } catch (error) {
    showError(DELETE_ANNOTATIONS_ERROR_MESSAGE);
  } finally {
    setIsLoading(false);
  }
};

export const getUpdatedVisibility = (preferences, uuid) => ({
  ...preferences,
  [DISPLAYED_EXTERNAL_ANNOTATIONS]: preferences[
    DISPLAYED_EXTERNAL_ANNOTATIONS
  ].includes(uuid)
    ? preferences[DISPLAYED_EXTERNAL_ANNOTATIONS].filter(
      (annotation) => annotation !== uuid,
    )
    : [...new Set([...preferences[DISPLAYED_EXTERNAL_ANNOTATIONS], uuid])],
});

export const getUpdatedColorLegend = (preferences, uuid, color) => {
  const currentColorLegend = preferences[ANNOTATIONS_COLOR_LEGEND_FIELD][uuid];

  return {
    ...preferences,
    [ANNOTATIONS_COLOR_LEGEND_FIELD]: {
      ...preferences[ANNOTATIONS_COLOR_LEGEND_FIELD],
      [uuid]: {
        ...currentColorLegend,
        [color]: {
          ...currentColorLegend[color],
          isSelected: !currentColorLegend[color].isSelected,
        },
      },
    },
  };
};
